module.exports = __webpack_public_path__ + "assets/retina_DoubleAngleDetailed.0cd7e36ae45e21d7f6fedc725447dbc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_DoubleAngleDetailed.png
// module id = 656
// module chunks = 0